import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import PrimaryTable from '../helpers/primary-table'
import { catchError } from '../helpers/catch-error'


const WorkOrderAdd = () => {
    const navigate = useNavigate();
    // const [isBtn, setIsBtn] = useState(false);
    const [data, setData] = React.useState(null);
    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <a href={"/admin/work-order/" + row.work_order_id} className="btn btn-link" >{row.patient_last_name + " " + row.patient_first_name}</a>,
                id: "lastName",
                cell: info => info.getValue(),
                header: () => "Patient",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_name",
                header: "Facility",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "Client",
                footer: props => props.column.id
            },
            {
                accessorFn: row => <a onClick={() => deleteWorkOrder(row.work_order_id)} className="btn btn-sm btn-danger" >Delete</a>,
                id: "action",
                cell: info => info.getValue(),
                header: () => "REMOVE",
                footer: props => props.column.id,
                enableColumnFilter: false,
            enableSorting: false,

            }
        ],
        []
    )
    useEffect(() => {

        getFinishIncompleteWorkOrders();

    }, []);

    const getFinishIncompleteWorkOrders = async () => {

        await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-finish-incomplete-work-orders", {
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {

                    setData(response?.data?.work_orders);
                    if(!response?.data?.work_orders){
                        navigate("/admin/work-order");
                    }

                } else {

                    Swal.fire({ icon: "error", title: "Incomplete Work Order Failed to Load", text: response?.data?.message });

                }

            })
            .catch(function (error) {

                catchError(error,navigate)


            });

    }


    const deleteWorkOrder = async (work_order_id) => {

        Swal.fire({
            title: "Are you sure, you want to delete this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {

                axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-work-order",
                    { work_order_id: work_order_id },
                    {
                        withCredentials: true
                    })
                    .then(function (response) {

                        if (response?.data?.status) {

                            Swal.fire({ icon: "success", title: "Deleted", text: "Work order deleted successfully." });

                            getFinishIncompleteWorkOrders(response?.data?.work_orders);

                        } else {

                            Swal.fire({ icon: "error", title: "Unable to delete work order", text: response?.data?.message });

                        }

                    })
                    .catch(function (error) {
                      
                        catchError(error,navigate)
                    });

            }
        });

    }

    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-4 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">NEW WORK ORDER</h3>
                </div>

                <div className="col-md-8 col-sm-12 text-md-end -2">

                    <a href="/admin/work-order" className="btn btn-success text-light mx-1" >CREATE WORK ORDER</a>

                </div>
            </div>

            {data &&

<div className="card border-4 border-dark rounded-1 card-success mb-4" >

<div className="card-body p-0" >
                        <PrimaryTable columns={columns} data={data} canFilter={false}  />
                    </div>
                </div>

            }


        </>


    );
};

export default WorkOrderAdd;